import Vue from 'vue'
import App from './App.vue'
import router from './router'

import axios from 'axios'
window.axios = axios

import { VueJsonp } from 'vue-jsonp'
Vue.use(VueJsonp)

// import videojs from 'video.js'
// import 'videojs-contrib-hls'
// import 'video.js/dist/video-js.css'
// Vue.use(videojs)
// Vue.prototype.$video = videojs

// 自适应
import 'amfe-flexible'
import 'amfe-flexible/index.js'

// import wx from 'weixin-js-sdk'
// Vue.prototype.wx = wx

Vue.config.productionTip = false

router.afterEach((to, from, next) => {
  // 页面跳转后，返回顶部
  // window.scrollTo(0,0)
})

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app')
